// @flow

import type { KpiSelectorMapping } from '../../../../types/geminiType';

export const erv = 'erv';
export const glaDen = 'glaDen';
export const glaWithSst = 'glaWithSst';
export const glaWithoutSst = 'glaWithoutSst';
export const invAbt = 'invAbt';
export const invAdm = 'invAdm';
export const invAnn = 'invAnn';
export const invCtr = 'invCtr';
export const invFra = 'invFra';
export const invLsw = 'invLsw';
export const invMco = 'invMco';
export const invMgr = 'invMgr';
export const invMwo = 'invMwo';
export const invOin = 'invOin';
export const invPal = 'invPal';
export const invPli = 'invPli';
export const invRet = 'invRet';
export const invRie = 'invRie';
export const invSbr = 'invSbr';
export const invSch = 'invSch';
export const ocr = 'ocr';
export const dwellPercent = 'dwellPercent';
export const ocrDen = 'ocrDen';
export const ocrNum = 'ocrNum';
export const revPot = 'revPot';
export const rrv = 'rrv';
export const salesM = 'salesM';
export const salesNum = 'salesNum';
export const salesR12m = 'salesR12m';
export const salesR12ms = 'salesR12ms';
export const salesR12mWithoutSst = 'salesR12mWithoutSst';
export const salesYtd = 'salesYtd';
export const spotAbt = 'spotAbt';
export const spotAdm = 'spotAdm';
export const spotAnn = 'spotAnn';
export const spotCtr = 'spotCtr';
export const spotFra = 'spotFra';
export const spotLsw = 'spotLsw';
export const spotMco = 'spotMco';
export const spotMgr = 'spotMgr';
export const spotMwo = 'spotMwo';
export const spotOin = 'spotOin';
export const spotPal = 'spotPal';
export const spotPli = 'spotPli';
export const spotRet = 'spotRet';
export const spotRie = 'spotRie';
export const spotSbr = 'spotSbr';
export const spotSch = 'spotSch';
export const trv = 'trv';

export const occupancyCost = 'occupancyCost';

export const kpiSelectorMapping: KpiSelectorMapping = {
  ocr: {
    multipleSelect: [],
    kpis: [ocr],
  },
  salesR12m: {
    multipleSelect: [],
    kpis: [salesR12m, salesYtd, salesM],
  },
  salesR12mWithoutSst: {
    multipleSelect: [],
    kpis: [salesR12mWithoutSst],
  },
  glaWithSst: {
    multipleSelect: [],
    kpis: [glaWithSst],
  },
  glaWithoutSst: {
    multipleSelect: [],
    kpis: [glaWithoutSst],
  },
  erv: {
    multipleSelect: [],
    kpis: [erv, rrv, trv],
  },
  spotMgr: {
    multipleSelect: [
      spotMgr,
      spotSch,
      spotSbr,
      spotRet,
      spotMco,
      spotMwo,
      spotLsw,
      spotRie,
      spotPal,
      spotFra,
      spotAbt,
      spotPli,
      spotAdm,
      spotCtr,
      spotOin,
      spotAnn],
    kpis: [],
  },
  revPot: {
    multipleSelect: [],
    kpis: [revPot],
  },
  invSbr: {
    multipleSelect: [],
    kpis: [invSbr],
  },
  occupancyCost: {
    multipleSelect: [
      invMgr,
      invSch,
      invRet,
      invMco,
      invMwo,
      invLsw,
      invRie,
      invPal,
      invFra,
      invAbt,
      invPli,
      invAdm,
      invCtr,
      invOin,
      invAnn],
    kpis: [],
  },
};

export const SUM_TYPE = 'SUM';
export const AVG_TYPE = 'AVG';

